import { FC } from 'react'

const AfterPayIcon: FC = () => (
  <svg
    width="40"
    height="26"
    viewBox="0 0 40 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      y="0.5"
      width="40"
      height="25"
      rx="4"
      fill="#B2FCE4"
    />
    <path
      d="M29.4732 7.82289L23.2967 4.35805C21.4842 3.34086 19.2178 4.61195 19.2178 6.64711V7.00258C19.2178 7.32367 19.3943 7.62133 19.6803 7.7807L20.8467 8.43539C21.1889 8.62758 21.6162 8.38695 21.6162 8.00336V7.11899C21.6162 6.6768 22.1084 6.40024 22.5014 6.62211L27.8506 9.62367C27.9399 9.67228 28.0145 9.74409 28.0665 9.83153C28.1185 9.91898 28.1459 10.0188 28.1459 10.1205C28.1459 10.2223 28.1185 10.3221 28.0665 10.4096C28.0145 10.497 27.9399 10.5688 27.8506 10.6174L22.5014 13.619C22.1076 13.8401 21.6162 13.5643 21.6162 13.1213V12.651C21.6162 10.6159 19.3506 9.3432 17.5357 10.362L11.3592 13.8268C10.9479 14.0511 10.6046 14.3821 10.3654 14.785C10.1262 15.1879 10 15.6477 10 16.1163C10 16.5848 10.1262 17.0446 10.3654 17.4475C10.6046 17.8504 10.9479 18.1814 11.3592 18.4057L17.5357 21.8713C19.3482 22.8877 21.6162 21.6174 21.6162 19.5815V19.226C21.6162 18.9049 21.4396 18.6088 21.1537 18.4479L19.9873 17.7916C19.6451 17.5995 19.2178 17.8401 19.2178 18.2237V19.1081C19.2178 19.5502 18.7256 19.8268 18.3326 19.6049L12.9834 16.6034C12.8941 16.5545 12.8195 16.4826 12.7676 16.395C12.7157 16.3074 12.6883 16.2075 12.6883 16.1057C12.6883 16.0039 12.7157 15.904 12.7676 15.8164C12.8195 15.7289 12.8941 15.6569 12.9834 15.608L18.3326 12.6065C18.7264 12.3854 19.2178 12.6612 19.2178 13.1041V13.5745C19.2178 15.6104 21.4834 16.8823 23.2967 15.8635L29.4732 12.3987C29.8846 12.1748 30.2281 11.8441 30.4674 11.4415C30.7067 11.0389 30.833 10.5792 30.833 10.1108C30.833 9.64241 30.7067 9.1827 30.4674 8.78006C30.2281 8.37743 29.8846 8.04676 29.4732 7.82289Z"
      fill="black"
    />
  </svg>
)

export default AfterPayIcon
